import React, { Component, Fragment } from 'react'
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons'
import { message } from 'hljd'
import { VideoUploader } from 'hlj-components'
import Style from './style.module.less'

export default class extends Component {
  state = {
    modal_visible: false
  }

  can_save = true

  onUploadClick = e => {
    this.setState({
      modal_visible: true
    })
  }

  onVideoOk = e => {
    const result = {
      link: e.path,
      type: 'video',
      persistent_id: e.persistent_id,
      cover_path: e.cover_path,
      width: e.width,
      height: e.height
    }

    const { onChange } = this.props

    onChange(result)

    this.setState({
      modal_visible: false
    })
  }

  onVideoCancel = () => {
    this.setState({
      modal_visible: false
    })
  }

  onEditClick = () => {
    this.setState({
      modal_visible: true
    })
  }

  onDeleteClick = () => {
    const { onChange } = this.props
    onChange(null)
  }

  onVideoError = (file, err, msg) => {
    if (err && err.code === -600) {
      message.warn(`视频大小超过了500M`)
    } else if (msg) {
      message.error(msg)
    }
  }

  handleVideoDuration = (file, src, info) => {
    // let duration = info.avinfo.format.duration
    // if (+duration > 300) {
    //   message.error('视频最长不可超过5分钟')
    //   this.can_save = false
    // }
    this.can_save = true
  }

  messageVideoDuration = () => {
    message.error('视频最长不可超过5分钟')
  }

  render() {
    const { modal_visible } = this.state
    const { value } = this.props

    const video =
      value && value.link
        ? {
            data: {
              cover_path: value.cover_path,
              media_id: null,
              path: value.link,
              kind: 'video'
            }
          }
        : null

    return (
      <Fragment>
        <div style={{ marginBottom: '6px' }}>
          <p className={Style.text_desc}>
            在案例详情页展示，视频比例为 16:9，大小不能超过 500 MB，时长不超过 5
            分钟；支持 rmvb、avi 和 mp4 等格式；
          </p>
        </div>
        <div className={Style.wrapper}>
          {(!value || !value.link) && (
            <div className={Style.trigger} onClick={this.onUploadClick}>
              <div className={Style.content}>
                <div className={Style.plus}>+</div>
                <p>添加视频</p>
              </div>
            </div>
          )}

          {value &&
            value.link && (
              <div
                className={Style.video}
                style={{ backgroundImage: `url(${value.cover_path})` }}
              >
                <img
                  className={Style['video-icon']}
                  src="https://qnm.hunliji.com/o_1cv7o0nbm1vgu3od18lq1htt1fcj9.png"
                />
                <div className={Style.mask} />
                <div className={Style.operation}>
                  <EyeOutlined onClick={this.onEditClick} />
                  <DeleteOutlined onClick={this.onDeleteClick} />
                </div>
              </div>
            )}
        </div>

        <VideoUploader
          modal_visible={modal_visible}
          video={video}
          onVideoOk={this.onVideoOk} // 模态框点击确定后的回调
          onVideoCancel={this.onVideoCancel} // 模态框点击取消后的回调
          onVideoError={this.onVideoError}
          uploadOptions={{
            upload_url: 'https://up.qiniup.com', // 上传路径
            image_uptoken_url: '/p/wedding/home/APIUtils/image_upload_token', // 获取图片token的url
            video_uptoken_url:
              '/p/wedding/home/APIUtils/video_upload_token?from=MerchandiseItemExample', // 获取上传视频token的url
            domain_url: 'https://qnm.hunliji.com/' // 图片显示前缀路径
          }}
          hide_outside_cover={true} // 是否显示外部封面，默认为true
          // node_ref={ref} // 打开上传模态框的ref，在hide_out_cover=false时使用
          max="500mb" //上传视频的大小限制，
          onVideoUploaded={this.handleVideoDuration}
          video_types={'flv,mp4,mkv,wmv,avi,mov,rm,rmvb,mpeg,m4v'}
        />
      </Fragment>
    )
  }
}
